import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ArrowHookUpLeftRegular, ArrowRightFilled } from '@fluentui/react-icons';
import BoardingStructure from '../BoardingStructure';
import {
  useId,
  Toaster,
  MenuButton
} from '@fluentui/react-components';
import PdfAllPages from '../PdfAllPages';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../../../authConfig';
import { Spinner } from '@fluentui/react-components';

const API_URL = process.env.REACT_APP_API_URL

const PreviewTemplate = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const data = location.state;
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [responseExampleFromServer, setResponseExampleFromServer] =
    useState(null);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false)

  const getFile = async (templatesNumber, DocumentType, formData) => {
    try {
      setIsLoadingPdf(true)

      let tokenResponse;
      try {
        tokenResponse = await instance.acquireTokenSilent({
          ...silentRequest,
          account: account,
        });
      } catch (error) {
        console.error('Error acquiring token: ', error);
        instance.acquireTokenRedirect(silentRequest);
        return;
      }


      const response = await axios.post(
        `${API_URL}/templates/examples/pdf/preview?templateNumber=${templatesNumber}&documentType=${DocumentType}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + tokenResponse.accessToken,
          },
          responseType: 'blob',
        }
      );
      console.log('response data from get', response.data);

      setResponseExampleFromServer(window.URL.createObjectURL(response.data));
      setIsLoadingPdf(false)
    } catch (error) {
      console.error('Error getting file', error);
    } finally {
      // Set loading to false after the operation completes
      console.log('done get file pdf');

    }
  };


  useEffect(() => {
    const formData = new FormData();

    const logo = data?.companyLogo !== undefined ? data?.companyLogo : null; // รองรับ null และไม่ใส่ undefined
    const signature = data?.companySignature !== undefined ? data?.companySignature : null;

    formData.append('logo', logo); 
    formData.append('signature', signature); 

    getFile(data?.templates.styleId, data?.templates.type, formData);
    // eslint-disable-next-line 
  }, [data?.companyLogo, data?.companySignature, data?.templates.styleId, data?.templates.type]);


  const toasterId = useId('toaster');

  return (
    <BoardingStructure>
      <Toaster toasterId={toasterId} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "17px"
        }}
      >

        <div style={{
          marginTop: "17px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>

          <div
            style={{
              display: "flex",
              width: "100%",
              height: "30px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MenuButton
              appearance="primary"
              menuIcon={null} icon={<ArrowRightFilled />}
              onClick={() => {
                setCurrentStep(4)
                history.push({
                  pathname: "/boarding/company/form",
                  state: {
                    templates: data?.templates,
                    companyLogo: data?.companyLogo,
                    companySignature: data?.companySignature,
                    branchNumber:'00000'
                  },
                });
              }}
              style={{ marginRight: "10%" }}
            >
              {t('boarding.next')}
            </MenuButton>
            <MenuButton
              appearance="secendary"
              style={{ alignSelf: "center", }}

              icon={<ArrowHookUpLeftRegular />}

              menuIcon={null}
              onClick={() => {
                setCurrentStep(3);
                history.push({
                  pathname: "/boarding/templates/upload",
                  state: {
                    templates: data.templates,
                    companyLogo: data?.companyLogo,
                    companySignature: data?.companySignature,
                    back:true
                  },
                });
              }}
            >
              {t('boarding.back')}
            </MenuButton>
          </div>
        </div>

      </div>
      <div style={{ marginBottom: "50px"}} >
        {isLoadingPdf ?
          <Spinner label={t("boarding.loading")} style={{ height: "400px", width: "100%" }} size="extra-large"  ></Spinner> :
          <div style={{ border: "0.5px solid black",marginBottom:"none" }}>
            <PdfAllPages pdf={responseExampleFromServer} />
          </div>
        }
      </div>
    </BoardingStructure>

  );
};

export default PreviewTemplate;
